import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ReportsComponent } from './reports.component';
import { ReportsService } from './reports.service';
import { PaginationModule } from '../project/pagination/pagination.module';
import {DatePickerModule} from '@syncfusion/ej2-angular-calendars';
import {FormsModule} from '@angular/forms';
import {RegisterModule} from '../reportFilter/reportFilter.module';
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        PaginationModule,
        DatePickerModule,
        FormsModule,
        RegisterModule,
    ],
    declarations: [ReportsComponent],
    providers: [ReportsService],
    exports: [ReportsComponent]
})

export class ReportsModule {

}
